import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCode: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconCode"><Path d="M10.5 9L7.5 12L10.5 15M13.5 9L16.5 12L13.5 15M3.5 3.5H20.5V20.5H3.5V3.5Z" stroke="currentColor"/></CentralIconBase>;
});

export default IconCode;
